var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Th(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.355703 13.16V10.96L6.8957 1.6H10.1557V10.72H11.9157V13.16H10.1557V16H7.3557V13.16H0.355703ZM7.5357 4.6L3.4357 10.72H7.5357V4.6ZM15.4224 3.732V6.948C15.4224 7.172 15.4744 7.336 15.5784 7.44C15.6904 7.536 15.8744 7.584 16.1304 7.584H16.9104V9H15.8544C14.4384 9 13.7304 8.312 13.7304 6.936V3.732H12.9384V2.352H13.7304V0.707999H15.4224V2.352H16.9104V3.732H15.4224ZM22.2227 2.256C22.7267 2.256 23.1747 2.368 23.5667 2.592C23.9587 2.808 24.2627 3.132 24.4787 3.564C24.7027 3.988 24.8147 4.5 24.8147 5.1V9H23.1347V5.328C23.1347 4.8 23.0027 4.396 22.7387 4.116C22.4747 3.828 22.1147 3.684 21.6587 3.684C21.1947 3.684 20.8267 3.828 20.5547 4.116C20.2907 4.396 20.1587 4.8 20.1587 5.328V9H18.4787V0.12H20.1587V3.18C20.3747 2.892 20.6627 2.668 21.0227 2.508C21.3827 2.34 21.7827 2.256 22.2227 2.256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Th);
export default __webpack_public_path__ + "static/media/4th.0943a7cdba7e37ba17f46c74d7628899.svg";
export { ForwardRef as ReactComponent };